import React, { useState, useEffect } from "react";
import { Grid, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";

// Images
import FireAlarm from "../../assets/Images/FireAlarm.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    api.floor.cpmGetDevData().then((res) => {
      const selectedDevices = {
        NONGL_SS_FIRE_SEPARATION_SYSTEM: res["NONGL_SS_FIRE_SEPARATION_SYSTEM"],
      };
      setEquipmentData(selectedDevices);
    });
  }, []);

  const typeNameMap = {
    NONGL_SS_FIRE_SEPARATION_SYSTEM: "Suppression System",
  };

  const typeImageMap = {
    NONGL_SS_FIRE_SEPARATION_SYSTEM: FireAlarm,
  };

  const allowedParameters = {
    NONGL_SS_FIRE_SEPARATION_SYSTEM: {
      Fire_Separation_System_Device: "Status",
    },
  };

  const shouldShowParameter = (deviceType, attrKey) =>
    Object.keys(allowedParameters[deviceType] || {}).includes(attrKey);

  const getStatusColor = (deviceType, attrKey, val) => {
    if (deviceType === "NONGL_SS_FIRE_SEPARATION_SYSTEM") {
      if (attrKey === "Fire_Separation_System_Device") {
        if (val === undefined || val === null || val === "") {
          return "#9e9e9e"; // Grey for no data
        }
        
        // Check if value is "active" or 1 (alarm condition)
        if (val === "active" || val === 1 || val === "1" || val === true) {
          return "red"; // Alarm
        }
        
        // Check if value is in range 2500-3500
        const numVal = parseFloat(val);
        if (!isNaN(numVal)) {
          if (numVal >= 2500 && numVal <= 3500) {
            return "green"; // OK
          } else {
            return "red"; // Alarm
          }
        }
        
        // Default to green for any other non-active value
        return "green";
      }
    }
    return "#0123B4";
  };

  const getDisplayValue = (deviceType, attrKey, val) => {
    if (val === undefined || val === null || val === "") return "-";
    
    if (deviceType === "NONGL_SS_FIRE_SEPARATION_SYSTEM") {
      if (attrKey === "Fire_Separation_System_Device") {
        // Check if value is "active" or 1 (alarm condition)
        if (val === "active" || val === 1 || val === "1" || val === true) {
          return "Alarm";
        }
        
        // Check if value is in range 2500-3500
        const numVal = parseFloat(val);
        if (!isNaN(numVal)) {
          if (numVal >= 2500 && numVal <= 3500) {
            return "OK";
          } else {
            return "Alarm";
          }
        }
        
        // Default to OK for any other non-active value
        return "OK";
      }
    }
    return val;
  };

  const renderFireSeparationCard = () => {
    const selectedType = "NONGL_SS_FIRE_SEPARATION_SYSTEM";
    const devices = equipmentData[selectedType]
      ? Object.entries(equipmentData[selectedType]).sort((a, b) =>
          a[1].name.localeCompare(b[1].name)
        )
      : [];

    if (devices.length === 0) return null;

    const allParameters = [];
    devices.forEach(([deviceId, deviceInfo]) => {
      if (deviceInfo?.Eqp_Attributes) {
        Object.entries(deviceInfo.Eqp_Attributes).forEach(([attrKey, attrValue]) => {
          if (shouldShowParameter(selectedType, attrKey)) {
            allParameters.push({
              deviceId,
              deviceName: deviceInfo.name,
              attrKey,
              attrValue,
            });
          }
        });
      }
    });

    if (allParameters.length === 0) return null;

    return (
      <Grid item xs={12}>
        <Card className={classes.paper} style={{ minHeight: "60vh" }}>
          <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
            <Grid item xs={12} style={{ textAlign: "left", marginLeft: "2vh" }}>
              <div
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "3vh",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  lineHeight: "1.2",
                  textAlign: "left",
                }}
              >
                {typeNameMap[selectedType]}
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
            <Grid item xs={12} sm={3}>
              <img
                src={typeImageMap[selectedType]}
                alt={typeNameMap[selectedType]}
                style={{
                  width: "100%",
                  height: "50vh",
                  objectFit: "contain",
                  marginTop: "3.5vh",
                }}
              />
            </Grid>

            <Grid item xs={12} sm={9} style={{ paddingRight: "1vw" }}>
              <Grid container spacing={1}>
                {allParameters.map((param) => (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    key={`${param.deviceId}-${param.attrKey}`}
                  >
                    <Card className={classes.paper1}>
                      <div className={classes.cardHeading}>
                        {param.deviceName || "-"}
                      </div>
                      <div
                        style={{
                          fontSize: "2.5vh",
                          color: getStatusColor(
                            selectedType,
                            param.attrKey,
                            param.attrValue?.presentValue
                          ),
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          marginBottom: "2vh",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {getDisplayValue(
                          selectedType,
                          param.attrKey,
                          param.attrValue?.presentValue
                        )}
                      </div>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    );
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {renderFireSeparationCard()}
        </Grid>
      </Grid>
    </div>
  );
}